import { memo, useState } from "react";
import { Handle, Position } from "@xyflow/react";

import Textarea from "../../FormComponents/Textarea";
import { BaseNode } from "./CustomNode";

const FunctionNode = memo(({ id, selected, data }) => {
  const [hovered, setHovered] = useState(false);

  const handleStyle = {
    opacity: hovered || selected ? 1 : 0,
    background: "#3b82f6",
    width: "8px",
    height: "8px",
    border: "2px solid white",
    borderRadius: "50%",
    transition: "opacity 0.2s ease",
    boxShadow: "8px 8px 12px 0px rgba(237, 237, 237, 0.70)"
  };

  return (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <BaseNode selected={selected} hovered={hovered}>
        <Handle type="source" position={Position.TopLeft} id={`${id}-source-topleft`} style={handleStyle} />
        <Handle type="target" position={Position.TopLeft} id={`${id}-target-topleft`} style={handleStyle} />

        <Handle type="source" position={Position.TopRight} id={`${id}-source-topright`} style={handleStyle} />
        <Handle type="target" position={Position.TopRight} id={`${id}-target-topright`} style={handleStyle} />

        <Handle type="source" position={Position.BottomLeft} id={`${id}-source-bottomleft`} style={handleStyle} />
        <Handle type="target" position={Position.BottomLeft} id={`${id}-target-bottomleft`} style={handleStyle} />

        <Handle type="source" position={Position.BottomRight} id={`${id}-source-bottomright`} style={handleStyle} />
        <Handle type="target" position={Position.BottomRight} id={`${id}-target-bottomright`} style={handleStyle} />

        {/* Midpoints */}
        <Handle type="source" position={Position.Top} id={`${id}-source-top`} style={handleStyle} />
        <Handle type="target" position={Position.Top} id={`${id}-target-top`} style={handleStyle} />

        <Handle type="source" position={Position.Right} id={`${id}-source-right`} style={handleStyle} />
        <Handle type="target" position={Position.Right} id={`${id}-target-right`} style={handleStyle} />

        <Handle type="source" position={Position.Bottom} id={`${id}-source-bottom`} style={handleStyle} />
        <Handle type="target" position={Position.Bottom} id={`${id}-target-bottom`} style={handleStyle} />

        <Handle type="source" position={Position.Left} id={`${id}-source-left`} style={handleStyle} />
        <Handle type="target" position={Position.Left} id={`${id}-target-left`} style={handleStyle} />

        <Textarea
          label="Function"
          value={JSON.parse(JSON.stringify(data.jobTriggerFormula, null, 2))}
          onChange={(e) => data.setJobTriggerFormula(e.target.value)}
          readOnly={true}
        />
      </BaseNode>
    </div>
  );
});

export default FunctionNode;
